/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-elements-chart-gauge-pointer-top-length',
  templateUrl: './theme-option-elements-chart-gauge-pointer-top-length.component.html',
  styleUrls: ['./theme-option-elements-chart-gauge-pointer-top-length.component.css']
})
export class ThemeOptionElementsChartGaugePointerTopLengthComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'elements_chart_gauge_pointer_top_length';

  constructor() {}

  receiveValue(value: number) {
    this.themeOptions.setOption(this.optionType, value);
  }

}